import React, { useMemo } from "react";
import { GroupableWorkTimeGrid } from "./groupableWorkTimeGrid";
import {
    useWorkTimeReportData,
    WorkTimeReportData,
} from "../../../hooks/reporting/useWorkTimeReportData";
import { MainLayout } from "../../layout/mainLayout";
import { WorkTimeReportFilters } from "../WorkTimeReportFilters";
import { LoadingIndicator } from "../../framework/loadingIndicatorNew";
import { useAppSelector } from "../../../framework/customStore";
import {
    GroupingValue,
    setWorkTimeReportGroupByRow,
    setWorkTimeReportGrouping,
    setWorkTimeReportGroupingModeMultiple,
    setWorkTimeReportShowGroupedRows,
} from "../../../store/reportOptionsSlice";
import { ReportGroupingPicker } from "../components/reportGroupingPicker";

const dataInitialized = (data: WorkTimeReportData) =>
    !!data.workTimeReportData &&
    !!data.salaryRowTypes &&
    !!data.workTimeTypes &&
    !!data.vehicles &&
    !!data.costCenters &&
    !!data.customers &&
    !!data.employees &&
    !!data.employeeGroups;

export const GroupableWorkTimeReportMain = () => {
    const data = useWorkTimeReportData();
    const initialized = dataInitialized(data);

    const grouping = useAppSelector(
        (state) => state.reportOptions.workTimeGrouping
    );
    const groupByRow = useAppSelector(
        (state) => state.reportOptions.workTimeGroupByRow
    );
    const workTimeGroupingModeMultiple = useAppSelector(
        (state) => state.reportOptions.workTimeGroupingModeMultiple
    );
    const showGroupedRows = useAppSelector(
        (state) => state.reportOptions.workTimeShowGroupedRows
    );
    const groupingModeMultiple = useMemo(
        () => workTimeGroupingModeMultiple || !showGroupedRows,
        [workTimeGroupingModeMultiple, showGroupedRows]
    );

    const groupingOptions = useMemo(
        () => [
            GroupingValue.Employee,
            GroupingValue.Vehicle,
            GroupingValue.CostCenter,
            GroupingValue.Customer,
            GroupingValue.Date,
            GroupingValue.WorkTimeType,
            GroupingValue.WorkShift,
        ],
        []
    );

    return (
        <MainLayout
            noContainer
            topComponent={
                initialized ? (
                    <>
                        <WorkTimeReportFilters
                            vehicles={data.vehicles}
                            costCenters={data.costCenters}
                            employees={data.employees}
                            employeeGroups={data.employeeGroups}
                            workTimeTypes={data.workTimeTypes}
                            customers={data.customers}
                        />
                        {/* Grouping selectors */}
                        <ReportGroupingPicker
                            selectedGrouping={grouping}
                            groupByRow={groupByRow}
                            options={groupingOptions}
                            setGrouping={setWorkTimeReportGrouping}
                            setGroupByRow={setWorkTimeReportGroupByRow}
                            groupingModeMultiple={groupingModeMultiple}
                            enableGroupingModeSelection
                            setGroupingModeMultiple={
                                setWorkTimeReportGroupingModeMultiple
                            }
                            enableShowGroupedRowsSelection
                            showGroupedRows={showGroupedRows}
                            setShowGroupedRows={
                                setWorkTimeReportShowGroupedRows
                            }
                        />
                    </>
                ) : null
            }
            noTopContainer
        >
            <>
                <LoadingIndicator loading={data.loading || !initialized} />
                {initialized && <GroupableWorkTimeGrid {...data} />}
            </>
        </MainLayout>
    );
};
